import React from 'react';
import PropTypes from 'prop-types';
import { Show, styles } from '../Plans/Show';
import { withStyles } from '@material-ui/core/styles';
import T from 'i18n-react';
import ActionBar from '../../core/AppBar/ActionBar';
import DecisionDialog from './DecisionDialog';
import { withSnackbar } from 'notistack';
import compact from 'lodash/compact';

class Confirm extends Show {
  componentDidUpdate(prevProps, prevState, snapshot) {
    const { enqueueSnackbar } = this.props;
    const { loaded, isAcceptable = false } = this.state;
    if (!prevState.loaded && loaded && !isAcceptable) {
      enqueueSnackbar(T.translate('applicant.overlappingTerm'), {
        variant: 'info',
        autoHideDuration: 10000,
        anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
      });
    }
  }

  getPlanId(): * {
    return this.props.planId;
  }

  getPlanProps = () => {
    const data = this.props.plan;
    const { terms = [] } = data;
    const term = terms.find(({ id }) => id === parseInt(this.props.termId));
    term.expanded = true;
    return term
      ? {
          ...data,
          terms: [term],
        }
      : data;
  };

  otherRenderer(): * {
    const {
      applicantId,
      applicantName,
      requestedStartDate,
      requestedEndDate,
      bizReason,
    } = this.props;
    const {
      loaded,
      title,
      isAcceptable = false,
      business: { name, displayName } = {},
      businessFeatures = [],
    } = this.state;
    const dialogProps = {
      plan: title,
      applicantId,
      name: applicantName,
      features: businessFeatures,
      requestedStartDate,
      requestedEndDate,
      successMessage: T.translate('applicant.confirms.success', {
        name: displayName || name,
      }),
      bizReason,
    };

    return (
      loaded && (
        <ActionBar
          selector="footer"
          actions={compact([
            isAcceptable && {
              ButtonProps: {
                variant: 'contained',
                color: 'primary',
                children: T.translate('confirm.lastCheck'),
              },
              DialogComponent: DecisionDialog,
              DialogProps: {
                action: 'approve',
                DialogProps: { disableBackdropClick: true },
                ...dialogProps,
              },
            },
            {
              ButtonProps: { children: T.translate('confirm.reject') },
              DialogComponent: DecisionDialog,
              DialogProps: {
                action: 'reject',
                DialogProps: { disableBackdropClick: true },
                ...dialogProps,
              },
            },
          ])}
        />
      )
    );
  }
}

Confirm.propTypes = {
  termId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  planId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  applicantId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  applicantName: PropTypes.string,
};

export default withSnackbar(withStyles(styles)(Confirm));
